import { z } from 'zod';

export const TransitGenerateReportDataSchema = z.object({
  transitId: z.string().length(24, 'Invalid ObjectId'),
});
export type TransitGenerateReportData = z.infer<typeof TransitGenerateReportDataSchema>;
